import React, { ReactElement, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Locations } from '../models/locations';

const PersistanceNavigator = ( {children}: { children: ReactElement } ) => {
  const {pathname} = useLocation();
  const navigate = useNavigate();

  const [navigateCheckPassed, setNavigateCheckPassed] = React.useState(false);
  useEffect(()=>{
    const storedPathName = sessionStorage.getItem(('persisted_pathname'))
    if (!navigateCheckPassed && storedPathName === Locations.Edit) {
      navigate(Locations.Edit, {replace: true});
    }
    setNavigateCheckPassed(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setNavigateCheckPassed])


  useEffect(() => {
    sessionStorage.setItem('persisted_pathname', pathname);
  }, [pathname]);

  if (!navigateCheckPassed) {
    return null;
  }
  return children;
};

export default PersistanceNavigator;